import React, { useEffect, useState } from 'react';

import { Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { mediaSnapshot } from '../../api/firebase/firestore/media';
import { approve } from '../../api/firebase/firestore/negotiation';
import { black } from '../../constants/Colors';

import type { NegotiationType } from '../../api/firebase/firestore/negotiation/negotiationType';
import type { User } from 'firebase/auth';
import type { DocumentSnapshot } from 'firebase/firestore';

const styles = {
  approveButton: {
    '@media screen and (max-width:480px)': {
      width: '148px'
    },
    border: `1px solid #757575`,
    borderRadius: '4px',
    boxShadow: 'none',
    color: '#757575',
    height: '36px',
    marginRight: '16px',
    width: '200px'
  },
  buttons: {
    display: 'flex',
    marginTop: '24px',
    textAlign: 'center'
  },
  description: {
    marginTop: '16px'
  },
  descriptionText: {
    color: '#757575',
    fontSize: '12px',
    textAlign: 'center'
  },
  title: {
    color: black,
    fontSize: '14px',
    textAlign: 'center'
  }
};

interface Props {
  negotiation: NegotiationType;
  currentUser: User | null | undefined;
  init: () => Promise<void>;
  screen: number;
}
const RejectionPanel = (props: Props): React.ReactElement => {
  const { t } = useTranslation();
  const { negotiation, currentUser, init, screen } = props;
  const [media, setMedia] = useState<DocumentSnapshot | null>(null);

  useEffect(() => {
    void (async () => {
      const gotMedia = await mediaSnapshot(negotiation.mediaId);
      setMedia(gotMedia);
    })();
  }, [media]);

  async function approveAction(): Promise<void> {
    await approve(negotiation, currentUser, screen);
    await init();
  }

  return (
    <>
      <Typography sx={styles.title}>{t('message.reject')}</Typography>
      <Typography sx={styles.description}>
        <Typography sx={styles.descriptionText}>
          {t('message.rejectMessage')}
        </Typography>
      </Typography>

      <Grid container justifyContent="center" alignItems="center">
        <Grid item sx={styles.buttons}>
          <Button sx={styles.approveButton} onClick={approveAction}>
            {t('message.approveButton')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
export default RejectionPanel;
